import React from 'react';
import PlanCard from './PlanCard';

const PlanGrid = ({ plans, currentPlan, isAnnual, getPlanAction, actionLoading }) => {
  // Only show paid plans in the grid (not free)
  const paidPlans = plans.filter(p => p.name !== 'free');

  // Ensure order: Light, Starter, Pro, Max
  const sortedPlans = [...paidPlans].sort((a, b) => {
    const order = { light: 0, starter: 1, pro: 2, max: 3 };
    return (order[a.name] ?? 999) - (order[b.name] ?? 999);
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 items-center md:pt-6 md:pb-4">
      {sortedPlans.map((plan, index) => (
        <div
          key={plan.name}
          className="animate-zoom-in"
          style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'backwards' }}
        >
          <PlanCard
            plan={plan}
            currentPlan={currentPlan}
            isAnnual={isAnnual}
            getPlanAction={getPlanAction}
            actionLoading={actionLoading}
          />
        </div>
      ))}
    </div>
  );
};

export default PlanGrid;
